module.exports = __webpack_public_path__ + "static/media/icone-webchat.71885475.png";